import type { FormKitTypeDefinition } from '@formkit/core'

export function makeRadioOrCheckboxInput() {
  return {
    type: 'input',
    props: ['options', 'name'],
    schema: [
      {
        $el: 'div',
        for: ['option', 'index', '$options'],
        attrs: {
          class: 'flex items-center gap-x-2',
        },
        children: [
          {
            $el: 'input',
            attrs: {
              type: '$type',
              id: '$: $id + $index',
              name: '$id',
              value: '$option.value',
              class: 'w-6',
              onInput: '$handlers.DOMInput',
            },
            bind: '$attrs',
          },
          {
            $el: 'label',
            attrs: {
              for: '$: $id + $index',
              class: 'flex-grow',
            },
            children: [
              {
                $el: 'p',
                if: '$option.label',
                children: '$option.label',
                attrs: {
                  class: 'text-body font-bold',
                },
              },
              {
                $el: 'p',
                if: '$option.help',
                children: '$option.help',
                attrs: { class: 'text-bunce-base text-caption' },
              },
            ],
          },
        ],
      },
      {
        $el: 'ul',
        if: '$messages.length',
        attrs: {
          class: '$classes.messages',
        },
        children: [
          {
            $el: 'li',
            for: ['message', '$messages'],
            attrs: {
              class: '$classes.message',
            },
            children: '$message.value',
          },
        ],
      },
    ],
  } as unknown as FormKitTypeDefinition
}
